import { ChangeEvent, ComponentPropsWithRef, FocusEvent } from 'react';
import { Controller } from 'react-hook-form';

import { UploadFileItemData } from '../../../data/utils/upload.utils';
import { FileUpload } from '../file-upload';

type InputUploadControllerProps = Omit<
  ComponentPropsWithRef<typeof FileUpload>,
  'name' | 'defaultValue' | 'onChange' | 'onBlur'
> & {
  name: string;
  defaultValue?: UploadFileItemData | null;
  onChange?: (
    value: UploadFileItemData | null,
    e: ChangeEvent<HTMLElement>
  ) => void;
  onBlur?: (
    value: UploadFileItemData | null,
    e: FocusEvent<HTMLElement>
  ) => void;
};

export function FileUploadController(props: InputUploadControllerProps) {
  const { defaultValue, onChange, onBlur, ...defaultProps } = props;

  return (
    <Controller
      render={({
        field: {
          onChange: onControllerChange,
          onBlur: onControllerBlur,
          value,
        },
        fieldState: { error },
      }) => (
        <FileUpload
          {...defaultProps}
          onChange={(val, e) => {
            onControllerChange(val);

            onChange?.(val, e);
          }}
          onBlur={(val, e) => {
            onControllerChange(val);

            onControllerBlur();

            onBlur?.(val, e);
          }}
          value={value ?? ''}
          error={error?.message}
        />
      )}
      name={props.name}
      defaultValue={defaultValue ?? ''}
    />
  );
}
